// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IStateDto
 */
export interface IStateDto {
    /**
     * 
     * @type {number}
     * @memberof IStateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IStateDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof IStateDto
     */
    name?: string;
}

/**
 * Check if a given object implements the IStateDto interface.
 */
export function instanceOfIStateDto(value: object): value is IStateDto {
    return true;
}

export function IStateDtoFromJSON(json: any): IStateDto {
    return IStateDtoFromJSONTyped(json, false);
}

export function IStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function IStateDtoToJSON(json: any): IStateDto {
    return IStateDtoToJSONTyped(json, false);
}

export function IStateDtoToJSONTyped(value?: IStateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'name': value['name'],
    };
}

